import React from "react";
import {
  Box,
  Typography,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../layouts/LegalLayout";

const CookiePolicy: React.FC = () => {
  const { t } = useTranslation();

  // Definir un tipo para las filas
  interface CookieRow {
    cookie: string;
    type: string;
    purpose: string;
    moreInfo: string;
  }

  // Cargar las filas de cookies de forma más segura con un tipo específico
  const rows: CookieRow[] = Array.isArray(
    t("legal.cookiePolicy.cookiesTable.rows", { returnObjects: true })
  )
    ? (t("legal.cookiePolicy.cookiesTable.rows", {
        returnObjects: true,
      }) as CookieRow[])
    : []; // If the translation returns an array, type it as CookieRow[], otherwise use an empty array

  return (
    <LegalLayout>
      <Box sx={{ py: 4 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          {t("legal.cookiePolicy.title")}
        </Typography>
        <Typography variant="body1">
          <strong>{t("legal.cookiePolicy.intro")}</strong>
          <br />
          <br />
          <strong>1. {t("legal.cookiePolicy.whatAreCookies.title")}</strong>
          <br />
          {t("legal.cookiePolicy.whatAreCookies.description")}
          <br />
          <br />
          <strong>2. {t("legal.cookiePolicy.typesOfCookies.title")}</strong>
          <br />
          {t("legal.cookiePolicy.typesOfCookies.description")}
          <br />
          <br />
          <strong>3. {t("legal.cookiePolicy.managingCookies.title")}</strong>
          <br />
          {t("legal.cookiePolicy.managingCookies.description")}
          <br />
          <br />
          <strong>4. {t("legal.cookiePolicy.thirdPartyCookies.title")}</strong>
          <br />
          {t("legal.cookiePolicy.thirdPartyCookies.description")}
          <br />
          <br />
          <strong>5. {t("legal.cookiePolicy.cookiesTable.title")}</strong>
          <br />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    {t("legal.cookiePolicy.cookiesTable.headers.cookie")}
                  </TableCell>
                  <TableCell>
                    {t("legal.cookiePolicy.cookiesTable.headers.type")}
                  </TableCell>
                  <TableCell>
                    {t("legal.cookiePolicy.cookiesTable.headers.purpose")}
                  </TableCell>
                  <TableCell>
                    {t("legal.cookiePolicy.cookiesTable.headers.moreInfo")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Mapeando las filas desde la traducción */}
                {rows.length > 0 &&
                  rows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.cookie}</TableCell>
                      <TableCell>{row.type}</TableCell>
                      <TableCell>{row.purpose}</TableCell>
                      <TableCell>
                        <Link
                          href={row.moreInfo}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t(
                            "legal.cookiePolicy.cookiesTable.headers.moreInfo"
                          )}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <strong>6. {t("legal.cookiePolicy.browserLinks.title")}</strong>
          <br />
          {t("legal.cookiePolicy.browserLinks.description")}
          <ul>
            {[
              {
                name: "Firefox",
                url: "https://support.mozilla.org/es/kb/activar-y-desactivar-cookies-preferencias-del-sitio-web",
              },
              {
                name: "Chrome",
                url: "https://support.google.com/chrome/answer/95647?hl=es",
              },
              {
                name: "Internet Explorer",
                url: "https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies",
              },
              {
                name: "Safari",
                url: "https://support.apple.com/es-es/guide/safari/sfri11471/mac",
              },
              {
                name: "Opera",
                url: "https://help.opera.com/es/latest/web-preferences/#cookies",
              },
            ].map((browser, index) => (
              <li key={index}>
                <Link
                  href={browser.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {browser.name}
                </Link>
              </li>
            ))}
          </ul>
          <br />
          <strong>
            7. {t("legal.cookiePolicy.googleAnalyticsOptOut.title")}
          </strong>
          <br />
          {t("legal.cookiePolicy.googleAnalyticsOptOut.description")}
          <Link
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("legal.cookiePolicy.googleAnalyticsOptOut.link")}
          </Link>
          <br />
          <br />
          <strong>8. {t("legal.cookiePolicy.exerciseRights.title")}</strong>
          <br />
          {t("legal.cookiePolicy.exerciseRights.description")}
        </Typography>
      </Box>
    </LegalLayout>
  );
};

export default CookiePolicy;
